import { ConfigSchema } from '@app/schemas/config';

export const config: ConfigSchema = {
  idleDelay: 30,
  languages: {
    allowUserChange: true,
    supported: ['en-CA'],
  },
  brightness: {
    allowUserChange: true,
    resetDelayAfterIdleDelay: 3600,
  },
  theme: {
    base: {
      background: {
        color: '#000000',
      },
      foreground: {
        color: '#FFFFFF',
      },
      border: {
        radius: '20px',
      },
    },
    primary: {
      background: {
        color: '#5838DA',
      },
      foreground: {
        color: '#FFFFFF',
      },
    },
    secondary: {
      background: {
        color: '#FFE500',
      },
      foreground: {
        color: '#000000',
      },
    },
    button: {
      primary: {
        normal: {
          background: {
            color: '#5838DA',
          },
          foreground: {
            color: '#FFFFFF',
          },
          border: {
            color: '#5838DA',
          },
        },
        active: {
          background: {
            color: '#000000',
          },
          foreground: {
            color: '#FFFFFF',
          },
          border: {
            color: '#5838DA',
          },
        },
      },
      secondary: {
        normal: {
          background: {
            color: '#FFE500',
          },
          foreground: {
            color: '#000000',
          },
          border: {
            color: '#FFE500',
          },
        },
        active: {
          background: {
            color: '#000000',
          },
          foreground: {
            color: '#FFFFFF',
          },
          border: {
            color: '#FFE500',
          },
        },
      },
    },
    card: {
      background: {
        color: '#15122f',
      },
      foreground: {
        color: '#FFFFFF',
      },
      border: {
        color: '#FFFFFF',
        radius: '20px',
      },
    },
    tabBar: {
      background: {
        color: '#5838DA',
      },
      button: {
        normal: {
          background: {
            color: '#6759E7',
          },
          foreground: {
            color: '#FFFFFF',
          },
          border: {
            color: '#6759E7',
          },
        },
        active: {
          background: {
            color: '#5838DA',
          },
          foreground: {
            color: '#FFE500',
          },
          border: {
            color: '#FFE500',
          },
        },
      },
    },
  },
  navigation: {
    backButton: {
      label: {
        fallback: 'en-CA',
        translations: {
          'en-CA': 'Close',
        },
      },
    },
    tabBar: {
      hiddenWhenIdle: false,
      items: [],
    },
  },
  pages: [],
};
